import { render } from "./CartModel.vue?vue&type=template&id=0385090c&scoped=true"
import script from "./CartModel.vue?vue&type=script&lang=js"
export * from "./CartModel.vue?vue&type=script&lang=js"

import "./CartModel.vue?vue&type=style&index=0&id=0385090c&lang=scss&scoped=true"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0385090c"]])

export default __exports__